import { render, staticRenderFns } from "./AccionesContrato.vue?vue&type=template&id=82033920"
import script from "./AccionesContrato.vue?vue&type=script&lang=js"
export * from "./AccionesContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports